import Model from "@/models/Model";
import User from "@/models/User";

export default class UserClass extends Model {
    resource() {
        return "classes";
    }

    users() {
        return this.hasMany(User);
    }
}
